(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InvoicePatientSearch', InvoicePatientSearch);

    InvoicePatientSearch.$inject = ['$resource'];

    function InvoicePatientSearch($resource) {
        var resourceUrl =  'api/_search/invoice-patients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
